export default __webpack_public_path__ + "static/media/viewFullProfile.b20d337d.svg";